<div mat-dialog-title class="dialog-header aum-typo-headline-3">
    <div class="dialog-title">
        <span class="title-span">{{ 'aumico_reports_ar_templates_list_dialog_title' | i18next }} </span>
    </div>
</div>
<div mat-dialog-content>
    <div>
        <aumico-table
            [options]="options"
            [data]="arTemplates"
            [delegate]="this"
            [singleSelection]="true"
            [savedSingleSelectionId]="null"
            detachPager="true"
        >
        </aumico-table>
    </div>
</div>
<div class="actions-footer">
    <mat-dialog-actions>
        <button aum-button (click)="selectArTemplate()" [disabled]="selectedArTemplateId == null" color="primary">
            {{ 'aumico_reports_ar_templates_list_dialog_save_button' | i18next }}
        </button>
    </mat-dialog-actions>
</div>
